/**
 * Date utility functions specific to analytics view
 */
import { format, parse, subDays, subHours, setHours } from 'date-fns';

/**
 * Formats a date to the required string format for analytics
 * @param {Date} date - Date to format
 * @returns {string} - Formatted date string
 */
export const formatAnalyticsDate = (date) => {
  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

/**
 * Calculates the slider minimum date for analytics (7:00 AM)
 * @param {string} cqlFechaMin - Base minimum date
 * @returns {string} - Formatted slider minimum date
 */
export const calculateSliderMinDate = (cqlFechaMin) => {
  const fecha = new Date(cqlFechaMin);
  fecha.setHours(7, 0, 0, 0);
  return format(fecha, 'yyyy-MM-dd HH:mm:ss');
};

/**
 * Adjusts issue time for Forecast Run Data Timestamp (FRDT)
 * @param {string} date - Date string
 * @param {string} time - Time string
 * @returns {string} - Adjusted datetime string
 */
export const modifiedIssueTimeFRDT = (date, time) => {
  try {
    // Combine date and time into a single Date object
    const dateTime = parse(`${date} ${time}`, 'yyyy-MM-dd HH:mm:ss', new Date());
    let adjustedDateTime;
    
    if (time === '01:00:00') {
      // If time is 01:00, subtract one day and set time to 18:00
      const previousDay = subDays(dateTime, 1);
      adjustedDateTime = setHours(previousDay, 18);
    } else if (['07:00:00', '13:00:00', '19:00:00'].includes(time)) {
      // For these times, subtract 7 hours
      adjustedDateTime = subHours(dateTime, 7);
    } else {
      adjustedDateTime = dateTime;
    }
    
    // Format the adjusted date and time
    return format(adjustedDateTime, 'yyyy-MM-dd HH:mm:ss');
  } catch (error) {
    console.error('Error adjusting issue time:', error);
    return `${date} ${time}`; // Return original combination on error
  }
};

/**
 * Handles slider time change for analytics (maintains day, updates hour)
 * @param {Date} nuevaFechaSlider - New slider date
 * @param {string} datePart - Current date part to maintain
 * @returns {string} - Updated datetime string
 */
export const handleAnalyticsSliderTimeChange = (nuevaFechaSlider, datePart) => {
  const nuevaHora = format(nuevaFechaSlider, 'HH:mm:ss');
  return `${datePart} ${nuevaHora}`;
};
